import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('scheduled_payment'),
    cancel: defineMessage('cancel_1'),
    edit: defineMessage('edit_1'),
    paymentDate: defineMessage('payment_date'),
    paymentTime: defineMessage('payment_time'),
    confirmCancellation: defineMessage('confirm_cancellation'),
    cancelButtonText: defineMessage('discard_changes_1'),
    cancellationPopupTitle: defineMessage('cancel_scheduled_payment'),
    cancellationPopupDescription: defineMessage('please_confirm_the_canc_eduled_for_date_at_time'),
    failedText: defineMessage('please_note_that_the_ba_ic_reason_learnmorelink'),
    twoFaIsNotEnabled: defineMessage('fa_is_not_enabled'),
};
